const e = "_wrapper_ajhwy_1", r = "_label_ajhwy_7", a = "_select_ajhwy_15", l = "_error_ajhwy_28", t = "_selectButton_ajhwy_47", o = "_iconWrapper_ajhwy_52", _ = "_placeholderDisplayed_ajhwy_90", c = {
  wrapper: e,
  label: r,
  select: a,
  error: l,
  selectButton: t,
  iconWrapper: o,
  placeholderDisplayed: _
};
export {
  c as default,
  l as error,
  o as iconWrapper,
  r as label,
  _ as placeholderDisplayed,
  a as select,
  t as selectButton,
  e as wrapper
};
